import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MultiselectModule} from '../../multiselect';
import {MultiselectSearchInputComponent} from './multiselect-search-input.component';

@NgModule({
    imports: [
        CommonModule,
        MultiselectModule,
        FormsModule
    ],
    declarations: [
        MultiselectSearchInputComponent
    ],
    exports: [
        MultiselectSearchInputComponent
    ]
})
export class MultiselectSearchInputModule {}
